module.exports = "<div class=\"loaderBar\" [hidden]=\"!show\"></div>"